// export function emailValidate(value) {
//   const emailRegexp = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
//   if (!value || !value.length) {
//     return '此欄位必填';
//   }
//   return emailRegexp.test(value);
// }

// export function mobileValidate(value) {
//   const phoneRegexp = /^(09)(\d){8}$/;
//   return phoneRegexp.test(value);
// }
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import zh_TW from 'vee-validate/dist/locale/zh_TW.js';

Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors'
});

Validator.localize('zh_TW', zh_TW);
const dict = {
  zh_TW: {
    messages: {
      required: '該欄位必填'
    }
  }
};
Validator.localize(dict);

Validator.extend('mobile', {
  getMessage: () => '須符合手機格式（09xxxxxxxx）',
  validate: value => {
    const regex = /^09[0-9]{8}$/;
    return regex.test(value);
  }
});

Validator.extend('identify', {
  getMessage: () => '須符合身分證碼格式（大寫英文字母開頭 + 數字共 10 位數）',
  validate: value => {
    const regex = /^[A-Z][0-9]{9}$/;
    return regex.test(value);
  }
});

Validator.extend('phone', {
  getMessage: () => '須符合電話號碼格式',
  validate: value => {
    const regex = /^[0-9]{7,10}$/;
    return regex.test(value);
  }
});
